var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 629,
    viewBox: "0 0 675 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.289 443.414L216.023 489.525C220.526 492.127 227.836 492.127 232.348 489.525L312.082 443.423C316.585 440.82 316.585 436.594 312.082 433.992L232.42 387.979C227.908 385.377 220.597 385.377 216.094 387.97L136.307 433.983C131.786 436.585 131.786 440.802 136.289 443.414Z",
    fill: "url(#paint0_linear_504_7563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.738 323.652L473.038 394.951C480.008 398.98 491.31 398.98 498.28 394.951L621.58 323.652C628.55 319.624 628.55 313.091 621.58 309.062L498.387 237.916C491.418 233.887 480.107 233.887 473.137 237.907L349.756 309.062C342.768 313.091 342.768 319.624 349.738 323.652Z",
    fill: "url(#paint1_linear_504_7563)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.294 304.872L249.176 349.1C253.858 351.603 261.456 351.603 266.147 349.1L349.029 304.872C353.711 302.369 353.711 298.322 349.029 295.818L266.219 251.681C261.536 249.186 253.93 249.177 249.248 251.672L166.312 295.809C161.611 298.322 161.611 302.378 166.294 304.872Z",
    fill: "url(#paint2_linear_504_7563)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M374.997 435.742L428.081 466.438C431.086 468.17 435.947 468.17 438.952 466.438L492.036 435.742C495.041 434.01 495.032 431.193 492.036 429.461L438.997 398.827C435.992 397.095 431.131 397.095 428.126 398.827L375.006 429.461C372.001 431.201 372.001 434.01 374.997 435.742Z",
    fill: "url(#paint3_linear_504_7563)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.894 85.5745L232.921 112.556C211.573 84.6503 168.437 90.1058 135.418 125.387C104.248 158.713 92.9547 206.924 107.8 237.728L80.8363 264.7C80.6121 264.279 80.3968 263.866 80.1994 263.435C79.9842 263.005 79.7779 262.583 79.5805 262.152C78.9616 260.869 78.3785 259.559 77.8403 258.231C77.4726 257.343 77.1317 256.445 76.7909 255.557C76.6204 255.099 76.459 254.651 76.2886 254.193C76.1271 253.745 75.9746 253.287 75.8221 252.829C75.5979 252.201 75.3916 251.573 75.2032 250.945C75.0686 250.505 74.9251 250.057 74.8085 249.617C74.7098 249.285 74.6112 248.953 74.5215 248.63C74.3869 248.172 74.2703 247.715 74.1358 247.257C74.1268 247.23 74.1178 247.185 74.1089 247.158C74.0012 246.701 73.8756 246.243 73.759 245.786C73.2478 243.794 72.8082 241.775 72.4315 239.729C72.3508 239.307 72.279 238.903 72.2072 238.491C72.0996 237.871 71.992 237.252 71.9023 236.624C71.7677 235.844 71.6601 235.045 71.5524 234.237C71.4717 233.645 71.391 233.044 71.3282 232.452C71.2744 232.021 71.2295 231.59 71.1757 231.151C71.0053 229.482 70.8617 227.795 70.7541 226.09C70.7093 225.462 70.6823 224.825 70.6554 224.197C70.6465 224.035 70.6375 223.874 70.6375 223.712C70.6106 222.914 70.5747 222.124 70.5568 221.325C70.5478 220.886 70.5478 220.446 70.5388 220.015C70.0634 181.073 87.3844 136.137 119.246 102.076C143.769 75.8569 172.213 61.1772 198.145 58.7276C202.908 58.279 207.59 58.2431 212.147 58.6289C213.564 58.7366 214.964 58.9071 216.354 59.0955C218.444 59.3916 220.498 59.7774 222.507 60.262C225.261 60.899 227.952 61.7245 230.571 62.7116L230.625 62.7295L230.858 62.8192C242.178 67.1621 252.135 74.7173 259.894 85.5745Z",
    fill: "#F3F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.331 296.177L113.407 295.801C112.895 295.585 112.393 295.361 111.882 295.128L114.331 296.177Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.571 62.7026C227.952 61.7156 225.27 60.8901 222.507 60.253C220.489 59.7685 218.435 59.3737 216.354 59.0865C214.973 58.8891 213.564 58.7276 212.147 58.62C207.59 58.2341 202.908 58.27 198.145 58.7187C172.213 61.1683 143.778 75.8569 119.246 102.067C87.3755 136.119 70.0546 181.064 70.539 220.006C70.539 220.446 70.548 220.886 70.5569 221.317C70.5749 222.115 70.6108 222.905 70.6377 223.703C70.6377 223.865 70.6466 224.026 70.6556 224.188C70.6825 224.816 70.7184 225.453 70.7543 226.081C70.8529 227.777 70.9965 229.473 71.1759 231.142C71.2297 231.582 71.2656 232.003 71.3283 232.443C71.3911 233.035 71.4719 233.636 71.5526 234.229C71.6513 235.036 71.7679 235.826 71.9024 236.615C71.9921 237.234 72.0998 237.854 72.2074 238.482C72.2792 238.903 72.3509 239.316 72.4317 239.72C72.8084 241.766 73.2479 243.785 73.7592 245.777C73.8668 246.234 73.9834 246.692 74.109 247.15C74.118 247.176 74.127 247.221 74.1359 247.248C74.2615 247.706 74.3871 248.163 74.5216 248.621C74.6113 248.944 74.701 249.276 74.8087 249.608C74.9432 250.048 75.0688 250.496 75.2034 250.936C75.4007 251.564 75.598 252.192 75.8223 252.82C75.9658 253.278 76.1273 253.736 76.2887 254.184C76.4502 254.642 76.6116 255.099 76.791 255.548C77.114 256.454 77.4727 257.343 77.8405 258.222C78.3787 259.55 78.9618 260.86 79.5807 262.143C79.778 262.574 79.9843 263.005 80.1996 263.426C80.4059 263.857 80.6212 264.27 80.8365 264.691L56.5728 246.835H56.5639C54.6981 241.838 53.2629 236.579 52.2493 231.124C44.2571 188.449 61.6229 133.418 99.0544 93.4169C123.578 67.198 152.022 52.5184 177.954 50.0688C184.197 49.4766 190.296 49.6022 196.163 50.4367C201.105 51.1366 205.868 52.3479 210.434 54.0797L210.667 54.1694C211.295 54.4117 211.932 54.6719 212.551 54.9321L213.188 55.2103L230.571 62.7026Z",
    fill: "url(#paint4_linear_504_7563)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.69 110.438L243.767 138.38L225.504 127.765L254.118 99.7517L271.69 110.438Z",
    fill: "url(#paint5_linear_504_7563)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244 166.079C241.865 182.015 235.837 198.624 226.392 213.878C221.961 221.011 216.812 227.795 210.919 234.085C182.96 263.956 147.824 272.435 124.736 257.441L107.469 247.715C218.005 259.667 225.513 127.756 225.513 127.756L243.776 138.371C245.301 147.057 245.354 156.442 244 166.079Z",
    fill: "url(#paint6_linear_504_7563)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.381 160.229C271.331 182.984 262.72 206.735 249.22 228.531C242.887 238.724 235.532 248.406 227.118 257.396C199.571 286.836 167.127 301.731 138.827 301.112H138.818C130.198 300.915 121.946 299.282 114.339 296.177L111.89 295.127C109.065 293.835 106.32 292.319 103.701 290.578C102.858 290.031 102.023 289.448 101.198 288.846C99.7003 287.761 98.2561 286.594 96.8389 285.365L124.744 257.45C147.833 272.444 182.968 263.965 210.927 234.094C216.821 227.804 221.969 221.02 226.401 213.887C235.846 198.633 241.874 182.024 244.008 166.088C245.363 156.442 245.309 147.057 243.775 138.389L271.699 110.456C276.049 125.531 276.847 142.588 274.381 160.229Z",
    fill: "#F3F6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.735 257.45L96.8297 285.365L78.8988 274.203C78.8898 274.194 78.8809 274.185 78.8809 274.185L107.468 247.724L124.735 257.45Z",
    fill: "url(#paint7_linear_504_7563)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.81 301.112C104.491 303.185 79.6351 275.046 78.8906 274.203L96.8215 285.365C98.2388 286.594 99.6829 287.761 101.181 288.846C102.006 289.448 102.84 290.031 103.683 290.578C106.312 292.319 109.048 293.835 111.873 295.128C112.384 295.361 112.887 295.585 113.398 295.8L114.322 296.177C121.937 299.282 130.19 300.915 138.81 301.112Z",
    fill: "url(#paint8_linear_504_7563)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.412 221.236C118.322 221.236 118.224 221.227 118.125 221.2C117.587 221.047 117.273 220.482 117.425 219.944L135.033 158.919L168.957 207.893L186.243 128.007L203.321 177.34L211.008 146.276C211.143 145.729 211.699 145.397 212.237 145.531C212.785 145.666 213.116 146.222 212.982 146.761L203.644 184.501L186.691 135.536L169.944 212.909L135.787 163.603L119.372 220.509C119.264 220.949 118.86 221.236 118.412 221.236Z",
    fill: "url(#paint9_linear_504_7563)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.655 213.672C123.31 214.614 123.516 215.906 123.328 217.261C123.175 218.364 122.762 219.522 122.108 220.581C121.803 221.074 121.444 221.55 121.031 221.98C118.69 224.484 115.613 224.825 114.169 222.734C112.725 220.652 113.452 216.938 115.793 214.434C118.134 211.931 121.211 211.59 122.655 213.672Z",
    fill: "url(#paint10_linear_504_7563)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.715 156.981C140.37 157.923 140.576 159.215 140.388 160.57C140.236 161.674 139.823 162.831 139.168 163.89C138.863 164.383 138.504 164.859 138.092 165.29C135.751 167.793 132.674 168.134 131.23 166.043C129.786 163.962 130.512 160.247 132.853 157.744C135.194 155.24 138.271 154.899 139.715 156.981Z",
    fill: "url(#paint11_linear_504_7563)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.774 204.591C174.429 205.533 174.635 206.825 174.447 208.18C174.294 209.284 173.882 210.441 173.227 211.5C172.922 211.994 172.563 212.469 172.15 212.9C169.809 215.403 166.733 215.744 165.288 213.663C163.844 211.581 164.571 207.866 166.912 205.363C169.253 202.85 172.33 202.509 173.774 204.591Z",
    fill: "url(#paint12_linear_504_7563)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.862 127.227C191.517 128.169 191.723 129.461 191.535 130.816C191.382 131.919 190.969 133.077 190.315 134.136C190.01 134.629 189.651 135.105 189.238 135.536C186.897 138.039 183.82 138.38 182.376 136.298C180.932 134.217 181.659 130.502 184 127.998C186.341 125.486 189.418 125.145 190.862 127.227Z",
    fill: "url(#paint13_linear_504_7563)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.255 141.996C216.91 142.938 217.116 144.23 216.928 145.585C216.776 146.689 216.363 147.846 215.708 148.905C215.403 149.399 215.044 149.874 214.632 150.305C212.291 152.808 209.214 153.149 207.77 151.068C206.326 148.986 207.052 145.271 209.393 142.768C211.735 140.255 214.802 139.914 216.255 141.996Z",
    fill: "url(#paint14_linear_504_7563)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.974 122.157L40.9829 128.716C40.9829 129.569 40.5255 130.367 39.7899 130.789L26.1018 138.694C25.151 139.241 23.958 138.559 23.958 137.456V131.57C23.958 130.663 24.4424 129.829 25.2228 129.371L39.3414 121.215C40.068 120.793 40.974 121.314 40.974 122.157Z",
    fill: "url(#paint15_linear_504_7563)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57841 162.867C1.22859 162.867 0.88773 162.688 0.699362 162.356C0.421294 161.871 0.582753 161.243 1.06713 160.965L40.472 138.192C40.9564 137.904 41.5843 138.075 41.8624 138.559C42.1404 139.044 41.979 139.672 41.4946 139.95L2.0897 162.723C1.92824 162.822 1.75781 162.867 1.57841 162.867Z",
    fill: "url(#paint16_linear_504_7563)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5785 173.006C1.23764 173.006 0.896784 172.827 0.708415 172.513C0.421378 172.028 0.573867 171.409 1.04927 171.113L40.4542 147.308C40.9385 147.012 41.5575 147.173 41.8535 147.649C42.1405 148.134 41.988 148.753 41.5126 149.049L2.10772 172.854C1.94627 172.953 1.7579 173.006 1.5785 173.006Z",
    fill: "url(#paint17_linear_504_7563)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M311.786 142.642L311.795 149.201C311.795 150.054 311.337 150.852 310.602 151.274L296.913 159.179C295.963 159.726 294.77 159.045 294.77 157.941V152.055C294.77 151.148 295.254 150.314 296.034 149.856L310.153 141.7C310.88 141.287 311.786 141.808 311.786 142.642Z",
    fill: "url(#paint18_linear_504_7563)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M296.555 168.762C296.205 168.762 295.864 168.583 295.676 168.251C295.398 167.766 295.559 167.138 296.044 166.86L335.449 144.087C335.933 143.8 336.561 143.97 336.839 144.455C337.117 144.939 336.956 145.567 336.462 145.845L297.057 168.619C296.896 168.717 296.725 168.762 296.555 168.762Z",
    fill: "url(#paint19_linear_504_7563)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M296.554 178.902C296.213 178.902 295.872 178.722 295.684 178.408C295.397 177.924 295.549 177.304 296.025 177.008L335.43 153.203C335.914 152.907 336.533 153.069 336.829 153.544C337.116 154.029 336.964 154.648 336.479 154.944L297.074 178.749C296.913 178.848 296.733 178.902 296.554 178.902Z",
    fill: "url(#paint20_linear_504_7563)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.298 62.1283L258.307 72.4023C258.307 73.7482 257.589 74.9865 256.432 75.6595L234.985 88.051C233.487 88.9124 231.621 87.8357 231.621 86.1039V76.8798C231.621 75.4621 232.384 74.143 233.612 73.4342L255.741 60.6568C256.88 59.9928 258.298 60.8183 258.298 62.1283Z",
    fill: "url(#paint21_linear_504_7563)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.682 287.025L157.691 297.299C157.691 298.645 156.974 299.883 155.817 300.556L134.37 312.948C132.872 313.809 131.006 312.732 131.006 311.001V301.776C131.006 300.359 131.768 299.04 132.997 298.331L155.126 285.553C156.265 284.889 157.682 285.706 157.682 287.025Z",
    fill: "url(#paint22_linear_504_7563)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2674 173.688L83.2763 183.962C83.2763 185.308 82.5588 186.547 81.4016 187.219L59.9545 199.611C58.4566 200.472 56.5908 199.396 56.5908 197.664V188.44C56.5908 187.022 57.3533 185.703 58.5821 184.994L80.711 172.217C81.8412 171.562 83.2584 172.378 83.2674 173.688Z",
    fill: "url(#paint23_linear_504_7563)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M261.93 221.927L261.939 232.201C261.939 233.547 261.222 234.785 260.065 235.458L238.618 247.849C237.12 248.711 235.254 247.634 235.254 245.902V236.678C235.254 235.26 236.016 233.941 237.245 233.232L259.374 220.455C260.504 219.791 261.93 220.617 261.93 221.927Z",
    fill: "url(#paint24_linear_504_7563)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 62.1283L161.055 72.4023C161.055 73.7482 160.337 74.9865 159.18 75.6595L137.733 88.051C136.235 88.9124 134.369 87.8357 134.369 86.1039V76.8798C134.369 75.4621 135.132 74.143 136.36 73.4342L158.489 60.6568C159.628 59.9928 161.046 60.8183 161.046 62.1283Z",
    fill: "url(#paint25_linear_504_7563)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M455.528 5.67087C456.694 4.96202 458.13 4.68386 459.538 5.02483C460.031 5.14147 460.525 5.3299 461 5.60806L463.162 6.86427L661.666 121.538C665.129 123.539 667.264 127.245 667.264 131.247V270.506C667.264 271.403 667.093 272.247 666.806 273C666.393 274.068 665.721 274.974 664.895 275.683L670.349 272.085L670.385 272.058C672.358 270.901 673.767 268.774 673.767 266.154V126.895C673.767 122.893 671.632 119.187 668.17 117.186L467.494 1.25621C465.467 0.0897332 463.144 0.412757 461.52 1.67794L455.528 5.67087Z",
    fill: "url(#paint26_linear_504_7563)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M452.937 151.05C452.937 155.689 455.403 159.969 459.413 162.284L657.029 276.41C659.72 277.971 662.824 277.451 664.896 275.683C665.721 274.974 666.394 274.059 666.807 273C667.094 272.247 667.264 271.403 667.264 270.506V131.247C667.264 127.245 665.129 123.539 661.667 121.538L463.162 6.86424L461 5.60804C460.525 5.32988 460.032 5.14145 459.538 5.0248C458.13 4.68383 456.695 4.96199 455.529 5.67085L455.439 5.73366C454.713 6.20025 454.094 6.83733 453.654 7.60002C453.215 8.36272 452.954 9.25104 452.954 10.2381L452.937 151.05Z",
    fill: "#F3F6FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M606.753 129.874V172.827L643.799 181.01C642.579 168.215 636.488 154.316 626.334 143.477C620.226 136.944 613.444 132.377 606.753 129.874Z",
    fill: "url(#paint27_linear_504_7563)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M606.752 213.51V172.827L581.17 192.513C582.964 195.089 584.955 197.556 587.144 199.898C593.261 206.439 600.061 210.998 606.752 213.51Z",
    fill: "url(#paint28_linear_504_7563)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M569.976 164.59C570.056 165.236 570.155 165.873 570.272 166.528L606.752 172.827L581.125 131.65C578.82 133.23 576.775 135.266 575.026 137.77C570.119 144.858 568.558 154.459 569.976 164.59Z",
    fill: "url(#paint29_linear_504_7563)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M581.126 131.65L606.753 172.827V129.874C597.362 126.338 588.114 126.859 581.126 131.65Z",
    fill: "url(#paint30_linear_504_7563)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M606.753 172.827V213.51C619.239 218.176 631.42 215.708 638.462 205.569C643.009 199.019 644.687 190.297 643.79 181.01L606.753 172.827Z",
    fill: "#A4C9FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M570.271 166.528C571.581 174.2 574.595 182.105 579.116 189.4C579.762 190.459 580.443 191.491 581.17 192.504L606.752 172.818L570.271 166.528Z",
    fill: "url(#paint31_linear_504_7563)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M550.359 83.0531L550.341 96.9431C550.341 99.303 547.785 100.766 545.748 99.5901L475.173 58.8083C473.46 57.8213 472.401 55.9908 472.401 54.0078V38.6552C472.401 36.9055 474.294 35.8108 475.81 36.6902L547.498 78.0911C549.265 79.114 550.359 81.0073 550.359 83.0531Z",
    fill: "url(#paint32_linear_504_7563)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M550.34 118.684V183.594C550.34 187.139 546.51 189.373 543.434 187.614L476.715 149.713C474.042 148.196 472.383 145.352 472.383 142.274V74.493C472.383 71.828 475.271 70.1591 477.576 71.496L545.864 110.932C548.636 112.529 550.34 115.49 550.34 118.684Z",
    fill: "url(#paint33_linear_504_7563)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M530.85 125.495C530.724 125.495 530.589 125.459 530.464 125.396L491.507 102.919C491.14 102.704 491.014 102.237 491.229 101.878C491.445 101.51 491.911 101.385 492.279 101.6L531.235 124.077C531.603 124.293 531.729 124.759 531.513 125.118C531.37 125.36 531.11 125.495 530.85 125.495Z",
    fill: "url(#paint34_linear_504_7563)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M540.599 142.409C540.474 142.409 540.339 142.373 540.213 142.31L481.756 108.545C481.389 108.33 481.263 107.863 481.478 107.495C481.685 107.127 482.16 107.002 482.528 107.217L540.985 140.982C541.353 141.197 541.478 141.664 541.263 142.032C541.128 142.265 540.868 142.409 540.599 142.409Z",
    fill: "url(#paint35_linear_504_7563)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M540.599 153.652C540.474 153.652 540.339 153.616 540.214 153.553L481.748 119.788C481.38 119.573 481.254 119.106 481.47 118.738C481.685 118.37 482.151 118.245 482.519 118.46L540.985 152.225C541.353 152.441 541.478 152.907 541.263 153.275C541.129 153.508 540.868 153.652 540.599 153.652Z",
    fill: "url(#paint36_linear_504_7563)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M540.599 164.913C540.474 164.913 540.339 164.877 540.214 164.814L480.438 130.295C480.07 130.08 479.945 129.613 480.16 129.246C480.375 128.878 480.842 128.752 481.209 128.967L540.985 163.486C541.353 163.702 541.478 164.168 541.263 164.536C541.129 164.778 540.868 164.913 540.599 164.913Z",
    fill: "url(#paint37_linear_504_7563)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M578.452 52.9042V93.3271L592.454 101.412L592.445 60.9888L578.452 52.9042Z",
    fill: "url(#paint38_linear_504_7563)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M609.229 45.8425V111.201L623.23 119.277L623.221 53.9271L609.229 45.8425Z",
    fill: "url(#paint39_linear_504_7563)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M640.031 37.8836V128.16L654.042 136.244L654.033 45.9592L640.031 37.8836Z",
    fill: "url(#paint40_linear_504_7563)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M638.444 334.438L640.722 333.119L604.708 270.739L569.223 291.233L525.037 235.108L498.827 250.245L481.56 210.396L454.686 194.846L453.367 197.126L479.488 212.245L497.589 253.996L524.382 238.518L568.568 294.652L603.748 274.328L638.444 334.438Z",
    fill: "#F3F6FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M455.34 186.502V206.915L446.496 191.598L455.34 186.502Z",
    fill: "#F3F6FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M264.101 332.455L263.025 333.576L260.765 329.907C260.765 329.907 260.998 326.542 261.68 321.23C262.361 315.918 262.002 310.085 262.002 310.085L263.805 307.035C263.994 308.955 264.083 311.037 263.958 313.657C263.644 320.099 263.258 322.908 263.572 328.058C263.671 329.583 263.868 331.091 264.101 332.455Z",
    fill: "url(#paint41_linear_504_7563)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M285.683 401.465C285.683 401.465 286.795 404.184 286.544 407.271C286.293 410.357 283.853 408.769 277.242 407.316C272.918 406.364 269.375 405.342 269.914 403.942C270.452 402.542 279.7 401.196 279.7 401.196L282.633 400.891L285.683 401.465Z",
    fill: "#012860"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M277.431 409.613C277.431 409.613 278.561 412.367 278.31 415.508C278.058 418.639 275.583 417.024 268.864 415.553C264.478 414.584 260.881 413.552 261.428 412.125C261.975 410.698 271.358 409.335 271.358 409.335L274.336 409.021L277.431 409.613Z",
    fill: "#012860"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M292.715 327.098C292.715 327.098 293.038 334.124 290.733 337.533C288.428 340.934 285.916 354.088 285.683 367.081C285.45 380.074 285.683 401.465 285.683 401.465C285.683 401.465 284.149 402.398 282.337 402.183C280.525 401.968 279.7 401.196 279.7 401.196L274.578 330.283L276.686 324.254L292.715 327.098Z",
    fill: "url(#paint42_linear_504_7563)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M284.562 334.151C284.562 334.151 284.893 341.284 282.552 344.739C280.211 348.193 277.664 361.536 277.431 374.726C277.197 387.916 277.431 409.613 277.431 409.613C277.431 409.613 275.87 410.564 274.031 410.34C272.192 410.115 271.358 409.335 271.358 409.335L266.155 337.381L268.29 331.261L284.562 334.151Z",
    fill: "#F3F6FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M267.725 277.577C266.191 279.021 265.976 281.13 265.976 281.13C265.976 281.13 265.061 282.422 264.549 282.341C264.047 282.269 260.486 280.681 260.486 280.681C260.486 280.681 261.544 278.94 260.683 277.891C259.822 276.832 260.217 275.899 260.522 275.262C260.701 274.903 261.437 274.122 262.262 273.413C263.312 272.516 264.487 271.753 264.702 272.22C265.097 273.036 263.168 275.235 263.599 275.262H263.608C263.617 275.262 263.617 275.262 263.617 275.262C264.828 275.271 266.846 275.19 268.909 274.66C268.918 274.66 269.259 276.132 267.725 277.577Z",
    fill: "url(#paint43_linear_504_7563)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M260.989 309C260.989 309 258.89 304.89 258.809 293.557C258.729 282.224 258.809 281.13 258.809 281.13C258.809 281.13 260.666 280.43 262.648 280.502C264.631 280.582 266.559 281.318 266.559 281.318L266.138 289.214L260.989 309Z",
    fill: "url(#paint44_linear_504_7563)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M269.573 274.481C269.573 274.481 269.869 277.819 269.573 279.883C269.277 281.955 272.677 283.633 272.793 283.552C272.91 283.472 277.054 279.219 277.054 279.219L276.058 272.956C276.058 272.956 275.933 271.915 275.637 271.798C275.332 271.681 271.134 270.982 271.134 270.982L269.573 274.481Z",
    fill: "url(#paint45_linear_504_7563)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M274.982 270.685C273.673 272.911 271.269 274.068 268.918 274.651C266.855 275.181 264.837 275.262 263.626 275.253C263.617 275.253 263.617 275.253 263.617 275.253H263.608C263.169 275.226 265.106 273.036 264.712 272.211C264.496 271.744 263.321 272.507 262.272 273.404C262.182 272.175 262.155 270.47 262.487 268.711C263.115 265.4 263.788 263.686 263.788 263.686L268.999 260.456C268.99 260.474 278.104 265.373 274.982 270.685Z",
    fill: "url(#paint46_linear_504_7563)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M292.742 327.583C292.742 327.583 291.594 331.746 284.93 335.084C278.256 338.413 265.393 338.108 265.393 338.108C265.393 338.108 264.64 335.685 264.093 332.455C263.859 331.091 263.662 329.583 263.563 328.049C263.249 322.89 263.635 320.081 263.949 313.648C264.084 311.028 263.985 308.946 263.796 307.026C263.518 304.226 263.025 301.776 262.693 298.474C262.146 292.929 265.115 284.252 266.99 281.982C268.864 279.712 274.525 277.639 274.525 277.639C274.525 277.639 278.552 276.715 281.781 276.975C283.091 277.083 284.167 277.918 284.975 279.371C284.975 279.371 284.983 279.398 285.01 279.443C285.118 279.64 285.217 279.838 285.306 280.053C285.315 280.08 285.324 280.107 285.342 280.134C286.159 282.036 286.607 284.755 286.589 288.147C286.589 288.631 286.58 289.125 286.562 289.636C286.347 294.867 287.531 299.856 288.93 304.747C289.594 307.062 290.303 309.35 290.94 311.629C292.949 318.726 292.742 327.583 292.742 327.583Z",
    fill: "url(#paint47_linear_504_7563)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M272.281 285.93C271.322 283.588 268.38 282.781 266.433 284.405C265.276 285.365 264.056 287.034 263.034 289.914C260.136 298.044 258.845 308.425 262.002 310.076C268.568 313.513 271.223 299.058 272.631 292.49C273.259 289.573 272.891 287.42 272.281 285.93Z",
    fill: "url(#paint48_linear_504_7563)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M288.966 304.756C287.567 299.874 286.383 294.876 286.598 289.645C286.759 285.562 286.32 282.323 285.378 280.152C286.643 282.826 290.778 291.763 291.603 297.075C292.061 300.054 290.616 302.746 288.966 304.756Z",
    fill: "url(#paint49_linear_504_7563)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M292.742 327.582C292.742 327.582 291.594 331.746 284.929 335.084C291.128 329.251 289.046 319.345 281.063 318.098C273.089 316.851 281.449 309.807 284.355 307.528C287.262 305.249 284.194 299.659 279.825 299.497C275.457 299.345 286.625 288.165 286.625 288.165C286.625 288.649 286.616 289.143 286.598 289.654C286.382 294.885 287.566 299.874 288.966 304.764C289.63 307.079 290.338 309.368 290.975 311.647C292.948 318.726 292.742 327.582 292.742 327.582Z",
    fill: "url(#paint50_linear_504_7563)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M261.383 255.261C261.383 255.261 260.181 260.735 263.778 263.705C267.375 266.675 267.393 267.087 267.716 268.397C268.048 269.698 267.366 270.999 267.366 270.999C267.366 270.999 270.075 268.137 270.802 269.07C271.528 270.012 269.698 272.767 272.228 273.341C274.757 273.916 278.866 272.336 280.166 269.528C281.467 266.71 280.965 264.072 280.965 264.072C280.965 264.072 281.288 258.913 278.319 256.777C276.148 255.216 275.681 256.517 273.914 255.539C273.313 255.207 273.851 253.233 271.582 253.233C269.86 253.233 269.133 255.216 267.151 254.274C265.545 253.511 267.68 251.322 265.492 250.335C263.321 249.348 261.383 255.261 261.383 255.261Z",
    fill: "#012860"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M442.639 383.107C442.639 383.107 440.1 391.236 444.675 390.814C449.25 390.393 458.982 385.144 458.561 383.107C458.139 381.07 447.779 382.882 447.779 382.882L444.505 381.671L442.639 383.107Z",
    fill: "url(#paint51_linear_504_7563)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M430.906 380.307C430.906 380.307 428.394 388.356 432.915 387.943C437.445 387.521 447.087 382.326 446.666 380.307C446.244 378.297 435.992 380.083 435.992 380.083L432.753 378.88L430.906 380.307Z",
    fill: "url(#paint52_linear_504_7563)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M436.809 332.921C436.809 332.921 439.347 341.661 439.06 346.874C438.773 352.088 442.549 384.228 442.549 384.228C442.549 384.228 442.989 384.955 444.532 384.857C446.075 384.758 446.954 384.031 446.954 384.031C446.954 384.031 447.447 332.886 446.182 329.386C444.917 325.878 436.809 327.448 436.809 327.448V332.921Z",
    fill: "url(#paint53_linear_504_7563)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M425.399 331.01C425.399 331.01 427.919 339.669 427.623 344.828C427.336 349.988 431.077 381.815 431.077 381.815C431.077 381.815 431.507 382.533 433.041 382.443C434.575 382.344 435.445 381.626 435.445 381.626C435.445 381.626 435.929 330.983 434.673 327.511C433.418 324.038 425.39 325.6 425.39 325.6V331.01H425.399Z",
    fill: "url(#paint54_linear_504_7563)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M452.802 332.769C452.802 332.769 449.16 331.1 446.407 331.181C440.37 331.36 441.025 332.984 434.629 333.298C428.323 333.603 421.838 329.242 421.838 329.242C421.865 328.417 420.241 325.644 421.766 320.189C423.183 315.119 422.556 313.253 421.91 310.74C423.049 309.529 424.933 308.318 427.803 308.919C432.952 310.005 442.146 307.259 442.146 307.259L442.137 307.25C438.953 307.887 435.176 308.102 431.212 307.178C430.001 306.891 428.906 306.604 427.92 306.317C424.681 305.375 422.654 304.441 421.407 303.679C421.407 303.679 423.022 303.544 425.444 303.347C428.449 303.104 432.692 302.772 436.638 302.494C441.975 302.108 446.765 301.812 447.205 301.965C448.219 302.324 449.968 304.612 449.968 304.612L452.802 332.769Z",
    fill: "url(#paint55_linear_504_7563)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M422.304 255.898C422.304 255.898 414.931 269.492 415.37 275.091C415.81 280.699 430.126 283.194 430.126 283.194L429.471 268.729L422.304 255.898Z",
    fill: "url(#paint56_linear_504_7563)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M442.89 234.022C442.89 234.022 445.527 237.952 444.89 239.352C444.576 240.043 447.447 243.91 445.554 245.22C442.971 247.015 439.015 246.773 434.844 243.426C430.673 240.079 433.292 234.022 433.292 234.022L437.607 230.433L442.89 234.022Z",
    fill: "url(#paint57_linear_504_7563)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M463.987 249.491C463.987 249.491 468.006 238.544 468.697 239.235C469.387 239.926 467.853 243.426 469.091 244.861C470.329 246.297 471.98 246.961 470.356 248.998C468.732 251.035 464.328 253.448 464.328 253.448L463.987 249.491Z",
    fill: "url(#paint58_linear_504_7563)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M455.17 276.778C449.492 273.88 447.339 269.986 447.079 269.492C447.249 269.896 448.344 272.597 447.76 273.943C447.572 274.382 447.285 274.777 447.007 275.181C447.007 275.181 446.98 275.217 446.944 275.271C446.917 275.306 446.89 275.342 446.863 275.378C446.846 275.405 446.819 275.432 446.801 275.468C446.227 276.311 445.769 277.245 446.209 278.734C446.63 280.161 447.429 281.605 448.254 284.064C448.263 284.073 448.263 284.073 448.263 284.073C448.819 285.724 449.375 287.833 449.842 290.713C450.99 297.855 451.142 303.966 451.142 303.966C451.142 303.966 450.73 304.217 449.976 304.594C448.496 305.33 445.688 306.541 442.145 307.241C438.961 307.878 435.185 308.093 431.22 307.169C430.009 306.882 428.915 306.595 427.928 306.308C424.69 305.366 422.663 304.432 421.416 303.67C419.738 302.656 419.442 301.956 419.442 301.956C419.442 301.956 419.532 301.095 419.685 299.704C420.169 295.352 421.272 285.841 422.16 281.722C422.923 278.178 422.044 273.53 421.416 268.631C421.075 266.037 420.815 263.364 420.896 260.752C421.209 250.981 432.96 250.604 432.96 250.604C432.96 250.604 441.428 250.155 446.209 256.553C449.438 260.869 452.38 263.776 454.273 264.521C455.188 264.889 455.851 264.745 456.192 264.019C456.416 263.543 456.811 262.466 457.34 261.093C457.349 261.084 457.349 261.084 457.349 261.084C459.296 255.997 462.947 246.835 465.808 248.747C469.45 251.187 461.251 279.883 455.17 276.778Z",
    fill: "url(#paint59_linear_504_7563)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M439.786 295.101C439.786 295.101 442.836 294.616 444.289 293.934C445.742 293.252 447.195 291.655 447.195 291.655C447.195 291.655 446.505 294.374 445.267 295.756C444.029 297.137 443.67 297.281 443.67 297.281C443.67 297.281 444.343 294.957 443.06 295.136C441.786 295.325 439.786 295.101 439.786 295.101Z",
    fill: "url(#paint60_linear_504_7563)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M448.245 284.073C448.074 283.884 445.141 280.654 443.239 280.125C441.275 279.577 441.383 279.434 443.491 278.384C445.123 277.567 446.325 276.114 446.792 275.477C446.217 276.32 445.76 277.253 446.2 278.743C446.63 280.179 447.428 281.614 448.245 284.073Z",
    fill: "url(#paint61_linear_504_7563)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M430.117 290.228C427.444 292.489 424.735 295.136 423.524 297.478C422.618 299.228 422.546 300.807 423.945 301.956C424.475 302.387 424.977 302.853 425.443 303.338C426.421 304.334 427.264 305.401 427.919 306.308C424.681 305.366 422.654 304.432 421.407 303.67C419.73 302.656 419.434 301.956 419.434 301.956C419.434 301.956 419.523 301.094 419.676 299.704C420.16 295.352 421.263 285.841 422.151 281.722C422.914 278.178 422.035 273.53 421.407 268.631C421.407 268.631 428.161 273.297 426.34 275.468C424.52 277.639 423.21 281.901 425.022 283.194C426.852 284.486 434.772 286.307 430.117 290.228Z",
    fill: "url(#paint62_linear_504_7563)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M457.233 265.544C457.376 266.89 454.264 264.539 454.264 264.539V264.53C455.179 264.898 455.842 264.754 456.183 264.027C456.408 263.552 456.802 262.475 457.331 261.102C456.946 262.134 457.089 264.207 457.233 265.544Z",
    fill: "url(#paint63_linear_504_7563)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M442.145 307.259C442.145 307.259 432.951 310.014 427.802 308.919C424.932 308.318 423.048 309.529 421.909 310.74C421.864 310.552 421.81 310.355 421.765 310.157C421.084 307.322 421.406 303.67 421.406 303.67C422.653 304.432 424.681 305.366 427.919 306.308C428.905 306.595 429.991 306.882 431.211 307.169C435.175 308.102 438.961 307.887 442.145 307.259Z",
    fill: "url(#paint64_linear_504_7563)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M442.89 234.022C442.89 234.022 439.221 234.74 440.881 239.908C442.54 245.077 444.209 247.544 441.67 249.357C439.132 251.178 440.36 252.632 441.051 254.301C442.621 258.087 443.204 264.243 434.844 263.588C426.484 262.933 419.281 258.509 421.667 252.345C422.995 248.917 428.359 247.401 425.551 244.879C424.098 243.569 424.071 239.648 425.551 235.476C427.471 230.074 430.619 226.458 436.378 227.328C442.137 228.208 442.89 234.022 442.89 234.022Z",
    fill: "#012860"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M544.968 453.562L515.592 470.521L486.197 453.571L515.592 436.612L544.968 453.562Z",
    fill: "url(#paint65_linear_504_7563)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M544.968 453.562V538.41L515.573 555.36L515.591 470.521L544.968 453.562Z",
    fill: "#F3F6FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M515.574 555.359L486.197 538.392V453.571L515.592 470.521L515.574 555.359Z",
    fill: "url(#paint66_linear_504_7563)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M480.375 438.748L450.999 455.706L421.604 438.757L450.999 421.798L480.375 438.748Z",
    fill: "url(#paint67_linear_504_7563)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M480.375 438.748V575.916L450.98 592.866L450.998 455.706L480.375 438.748Z",
    fill: "#F3F6FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M450.981 592.866L421.604 575.899V438.757L450.999 455.707L450.981 592.866Z",
    fill: "url(#paint68_linear_504_7563)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M415.729 422.022L386.352 438.99L356.958 422.031L386.352 405.081L415.729 422.022Z",
    fill: "url(#paint69_linear_504_7563)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M415.729 422.031V611.512L386.335 628.462L386.353 438.99L415.729 422.031Z",
    fill: "#F3F6FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M386.335 628.462L356.958 611.503V422.031L386.352 438.99L386.335 628.462Z",
    fill: "url(#paint70_linear_504_7563)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M338.301 598.268C327.824 597.505 319.15 592.57 313.194 584.01C305.937 573.556 303.677 558.895 306.825 542.735C309.956 526.691 318.065 511.033 329.654 498.651C343.62 483.72 360.456 475.806 375.849 476.927C386.308 477.69 394.982 482.607 400.911 491.158C407.477 500.607 409.97 513.788 407.943 528.252C406.4 539.747 402.077 551.483 395.439 562.206C392.255 567.338 388.559 572.166 384.469 576.544C371.364 590.542 355.756 598.384 341.18 598.384C340.22 598.375 339.261 598.34 338.301 598.268ZM398.57 492.782C393.143 484.967 385.222 480.472 375.652 479.781C361.344 478.74 344.938 486.528 331.753 500.607C308.655 525.291 301.39 561.972 315.553 582.377C320.989 590.21 328.936 594.715 338.516 595.414C352.814 596.455 369.211 588.667 382.397 574.579C386.362 570.344 389.941 565.669 393.026 560.689C399.449 550.317 403.638 538.966 405.127 527.857C407.046 514.102 404.714 501.648 398.57 492.782L399.745 491.966L398.57 492.782Z",
    fill: "url(#paint71_linear_504_7563)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M325.725 571.69C330.04 577.899 336.337 581.48 343.925 582.027C344.625 582.081 345.324 582.099 346.015 582.099C356.304 582.099 367.319 576.697 376.638 567.033L374.611 565.786C365.318 575.243 354.007 580.421 344.096 579.703C337.234 579.201 331.538 575.97 327.645 570.362C321.5 561.515 320.971 548.397 325.169 535.485L323.151 534.255C318.567 548.029 319.105 562.152 325.725 571.69ZM370.853 496.587C377.715 497.089 383.402 500.311 387.286 505.91C390.694 510.809 392.47 517.252 392.47 524.475C392.47 526.619 392.309 528.836 391.995 531.106C391.295 536.274 389.797 541.514 387.564 546.593L389.573 547.795C391.959 542.439 393.565 536.893 394.3 531.429C395.762 520.957 393.959 511.428 389.205 504.582C384.9 498.382 378.621 494.819 371.032 494.263C359.91 493.446 347.719 499.18 337.619 509.975C336.238 511.455 334.928 512.989 333.699 514.578L335.709 515.78C336.839 514.335 338.05 512.927 339.315 511.572C348.231 502.051 359.192 496.524 369.023 496.524C369.624 496.515 370.243 496.542 370.853 496.587Z",
    fill: "url(#paint72_linear_504_7563)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M368.646 531.106C369.991 533.044 370.413 535.673 370.027 538.454C369.722 540.716 368.87 543.084 367.525 545.247C366.897 546.261 366.161 547.221 365.327 548.118C360.528 553.251 354.24 553.942 351.271 549.67C348.311 545.408 349.791 537.79 354.599 532.667C359.389 527.543 365.686 526.843 368.646 531.106Z",
    fill: "url(#paint73_linear_504_7563)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M357.415 530.657C358.169 531.743 358.411 533.223 358.187 534.776C358.016 536.05 357.532 537.369 356.778 538.589C356.429 539.155 356.016 539.702 355.541 540.204C352.85 543.085 349.315 543.471 347.656 541.075C345.997 538.679 346.831 534.417 349.522 531.537C352.222 528.656 355.756 528.27 357.415 530.657Z",
    fill: "url(#paint74_linear_504_7563)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M480.294 556.741C475.387 556.382 471.324 554.076 468.534 550.057C465.135 545.157 464.076 538.293 465.556 530.72C467.028 523.201 470.822 515.87 476.249 510.073C482.797 503.083 490.681 499.369 497.884 499.898C502.782 500.257 506.845 502.563 509.626 506.565C512.702 510.988 513.868 517.162 512.918 523.945C512.191 529.329 510.173 534.83 507.06 539.845C505.571 542.25 503.84 544.511 501.921 546.557C495.785 553.116 488.466 556.786 481.64 556.786C481.191 556.786 480.743 556.768 480.294 556.741ZM508.522 507.328C505.984 503.667 502.27 501.558 497.785 501.235C491.085 500.75 483.398 504.393 477.226 510.988C466.409 522.555 463 539.738 469.638 549.294C472.185 552.964 475.908 555.072 480.393 555.404C487.093 555.889 494.771 552.246 500.943 545.642C502.8 543.659 504.477 541.469 505.921 539.136C508.935 534.273 510.89 528.961 511.59 523.757C512.496 517.305 511.411 511.473 508.522 507.328L509.07 506.942L508.522 507.328Z",
    fill: "url(#paint75_linear_504_7563)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M474.402 544.287C476.42 547.194 479.371 548.872 482.923 549.132C483.246 549.159 483.578 549.168 483.901 549.168C488.718 549.168 493.875 546.638 498.244 542.106L497.293 541.523C492.943 545.956 487.641 548.379 482.995 548.047C479.784 547.813 477.111 546.297 475.29 543.668C472.41 539.522 472.159 533.376 474.133 527.328L473.191 526.754C471.047 533.205 471.307 539.818 474.402 544.287ZM495.544 509.104C498.755 509.337 501.419 510.845 503.24 513.474C504.837 515.771 505.671 518.786 505.671 522.169C505.671 523.174 505.599 524.215 505.447 525.273C505.124 527.696 504.415 530.146 503.375 532.532L504.316 533.098C505.438 530.585 506.182 527.992 506.532 525.435C507.223 520.536 506.371 516.067 504.146 512.855C502.128 509.957 499.186 508.279 495.634 508.018C490.422 507.633 484.717 510.324 479.981 515.376C479.335 516.067 478.716 516.785 478.142 517.53L479.084 518.095C479.613 517.413 480.178 516.758 480.77 516.121C484.95 511.661 490.081 509.077 494.683 509.077C494.97 509.077 495.257 509.086 495.544 509.104Z",
    fill: "url(#paint76_linear_504_7563)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M494.512 525.273C495.14 526.18 495.337 527.418 495.158 528.71C495.014 529.769 494.611 530.881 493.983 531.895C493.687 532.371 493.346 532.82 492.951 533.241C490.7 535.646 487.758 535.969 486.367 533.968C484.977 531.967 485.677 528.405 487.928 526C490.17 523.604 493.122 523.281 494.512 525.273Z",
    fill: "url(#paint77_linear_504_7563)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M489.247 525.067C489.597 525.578 489.713 526.269 489.615 526.996C489.534 527.588 489.31 528.207 488.96 528.782C488.798 529.051 488.601 529.302 488.386 529.535C487.121 530.881 485.47 531.07 484.69 529.948C483.91 528.826 484.304 526.826 485.56 525.48C486.816 524.134 488.475 523.945 489.247 525.067Z",
    fill: "url(#paint78_linear_504_7563)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M544.968 507.956C541.891 507.731 539.335 506.278 537.586 503.765C535.451 500.688 534.787 496.381 535.711 491.625C536.635 486.905 539.012 482.302 542.42 478.659C546.529 474.271 551.48 471.938 556.001 472.27C559.078 472.495 561.625 473.939 563.374 476.452C565.303 479.233 566.038 483.11 565.446 487.363C564.989 490.746 563.724 494.191 561.769 497.35C560.836 498.857 559.741 500.275 558.539 501.567C554.691 505.685 550.099 507.991 545.811 507.991C545.533 507.983 545.246 507.974 544.968 507.956ZM562.693 476.936C561.096 474.639 558.764 473.32 555.956 473.114C551.749 472.809 546.923 475.097 543.048 479.242C536.258 486.501 534.123 497.287 538.285 503.281C539.882 505.587 542.223 506.906 545.04 507.112C549.247 507.417 554.063 505.129 557.938 500.984C559.105 499.736 560.154 498.364 561.06 496.901C562.953 493.85 564.182 490.512 564.621 487.246C565.177 483.199 564.495 479.538 562.693 476.936L563.042 476.694L562.693 476.936Z",
    fill: "url(#paint79_linear_504_7563)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M541.273 500.14C542.537 501.962 544.394 503.02 546.628 503.182C546.834 503.2 547.04 503.2 547.247 503.2C550.269 503.2 553.507 501.612 556.252 498.767L555.651 498.399C552.915 501.181 549.588 502.706 546.681 502.491C544.663 502.347 542.986 501.396 541.847 499.745C540.035 497.143 539.882 493.285 541.12 489.489L540.528 489.13C539.165 493.177 539.326 497.332 541.273 500.14ZM554.539 478.049C556.557 478.193 558.226 479.144 559.374 480.786C560.378 482.23 560.899 484.124 560.899 486.241C560.899 486.869 560.854 487.524 560.755 488.188C560.549 489.714 560.109 491.248 559.455 492.747L560.046 493.096C560.746 491.517 561.222 489.893 561.437 488.287C561.867 485.209 561.338 482.401 559.939 480.391C558.674 478.569 556.826 477.52 554.593 477.358C551.319 477.116 547.74 478.803 544.771 481.979C544.367 482.41 543.981 482.867 543.614 483.334L544.206 483.684C544.538 483.262 544.896 482.84 545.264 482.446C547.883 479.646 551.113 478.022 554.001 478.022C554.18 478.031 554.36 478.04 554.539 478.049Z",
    fill: "url(#paint80_linear_504_7563)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M553.893 488.206C554.288 488.781 554.413 489.552 554.297 490.369C554.207 491.033 553.956 491.733 553.561 492.37C553.373 492.666 553.157 492.953 552.915 493.213C551.507 494.721 549.65 494.927 548.78 493.671C547.91 492.415 548.349 490.18 549.758 488.673C551.166 487.157 553.023 486.95 553.893 488.206Z",
    fill: "url(#paint81_linear_504_7563)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M550.592 488.072C550.816 488.395 550.888 488.825 550.816 489.283C550.762 489.66 550.628 490.046 550.404 490.405C550.296 490.575 550.179 490.728 550.045 490.88C549.256 491.724 548.215 491.84 547.731 491.14C547.246 490.44 547.489 489.184 548.278 488.332C549.058 487.479 550.099 487.372 550.592 488.072Z",
    fill: "url(#paint82_linear_504_7563)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M136.154 414.368L112.222 400.541L64.0986 428.052L88.2816 442.023L136.154 414.368Z",
    fill: "url(#paint83_linear_504_7563)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M152.121 423.583L177.317 438.138L96.2562 483.496L72.3154 469.668L152.121 423.583Z",
    fill: "url(#paint84_linear_504_7563)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2563 391.326L64.0991 409.622L40.3916 395.929L72.3156 377.499L96.2563 391.326Z",
    fill: "url(#paint85_linear_504_7563)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M245.48 555.395V573.332C245.48 575.593 245.157 577.801 244.538 579.954C239.318 598.008 213.125 611.727 181.632 611.727C150.13 611.727 123.955 598.008 118.735 579.954C118.116 577.81 117.793 575.593 117.793 573.332V555.395C117.793 558.482 118.394 561.479 119.542 564.359C120.457 566.656 121.713 568.873 123.283 570.99C133.23 584.432 155.61 593.79 181.632 593.79C207.654 593.79 230.052 584.423 239.99 570.981C241.551 568.873 242.807 566.656 243.722 564.359C244.879 561.479 245.48 558.482 245.48 555.395Z",
    fill: "#C7DAFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M245.48 555.395C245.48 558.482 244.888 561.488 243.722 564.368C242.923 566.378 241.856 568.316 240.564 570.192C233.855 579.847 220.768 587.509 204.469 591.269C197.383 592.902 189.678 593.799 181.632 593.799C162.4 593.799 145.16 588.685 133.454 580.582C126.826 575.997 121.982 570.47 119.551 564.368C118.403 561.488 117.802 558.482 117.802 555.395C117.802 549.213 120.224 543.372 124.556 538.203C135.042 525.632 156.668 517.009 181.641 517.009C197.984 517.009 212.901 520.706 224.203 526.781C237.254 533.807 245.48 544.018 245.48 555.395Z",
    fill: "url(#paint86_linear_504_7563)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M224.185 526.772L180.116 552.901L133.445 580.573C126.817 575.988 121.973 570.461 119.542 564.359C118.394 561.479 117.793 558.473 117.793 555.386C117.793 549.204 120.215 543.363 124.547 538.194C135.033 525.623 156.66 517 181.632 517C197.975 517 212.892 520.697 224.185 526.772Z",
    fill: "#F22AFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M245.48 555.395C245.48 558.482 244.888 561.488 243.722 564.368C242.924 566.378 241.856 568.316 240.565 570.192L180.116 552.91L224.185 526.781C237.255 533.807 245.48 544.018 245.48 555.395Z",
    fill: "url(#paint87_linear_504_7563)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M224.185 526.772L180.116 552.901L124.538 538.194C135.024 525.623 156.65 517 181.623 517C197.975 517 212.892 520.697 224.185 526.772Z",
    fill: "#51A0FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M240.556 570.192C233.846 579.846 220.759 587.509 204.461 591.269L180.107 552.91L240.556 570.192Z",
    fill: "#913BFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M105.997 329.682C105.997 329.682 107.011 415.777 107.468 496.659C107.468 496.659 108.509 366.381 108.939 329.682H105.997Z",
    fill: "url(#paint88_linear_504_7563)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M107.468 331.952C113.478 331.952 118.349 327.079 118.349 321.068C118.349 315.057 113.478 310.184 107.468 310.184C101.459 310.184 96.5879 315.057 96.5879 321.068C96.5879 327.079 101.459 331.952 107.468 331.952Z",
    fill: "url(#paint89_linear_504_7563)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M384.863 116.594C384.863 116.594 385.877 202.689 386.334 283.571C386.334 283.571 387.375 153.293 387.805 116.594H384.863Z",
    fill: "url(#paint90_linear_504_7563)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M386.335 118.864C392.344 118.864 397.215 113.991 397.215 107.98C397.215 101.969 392.344 97.0957 386.335 97.0957C380.325 97.0957 375.454 101.969 375.454 107.98C375.454 113.991 380.325 118.864 386.335 118.864Z",
    fill: "url(#paint91_linear_504_7563)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M598.105 325.16C598.105 325.16 599.119 411.255 599.576 492.136C599.576 492.136 600.617 361.859 601.047 325.16H598.105Z",
    fill: "url(#paint92_linear_504_7563)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M599.568 327.43C605.577 327.43 610.449 322.557 610.449 316.546C610.449 310.535 605.577 305.662 599.568 305.662C593.559 305.662 588.688 310.535 588.688 316.546C588.688 322.557 593.559 327.43 599.568 327.43Z",
    fill: "url(#paint93_linear_504_7563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_7563",
    x1: 132.914,
    y1: 438.745,
    x2: 315.454,
    y2: 438.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_7563",
    x1: 344.513,
    y1: 316.44,
    x2: 626.802,
    y2: 316.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_504_7563",
    x1: 162.783,
    y1: 300.401,
    x2: 352.545,
    y2: 300.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_504_7563",
    x1: 372.75,
    y1: 432.639,
    x2: 494.292,
    y2: 432.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_504_7563",
    x1: 50.3414,
    y1: 157.188,
    x2: 230.573,
    y2: 157.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_504_7563",
    x1: 225.505,
    y1: 119.066,
    x2: 271.691,
    y2: 119.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_504_7563",
    x1: 107.465,
    y1: 196.23,
    x2: 244.967,
    y2: 196.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_504_7563",
    x1: 78.8753,
    y1: 266.543,
    x2: 124.736,
    y2: 266.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_504_7563",
    x1: 78.8965,
    y1: 287.712,
    x2: 138.812,
    y2: 287.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_504_7563",
    x1: 117.397,
    y1: 174.616,
    x2: 213.029,
    y2: 174.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_504_7563",
    x1: 113.431,
    y1: 218.203,
    x2: 123.399,
    y2: 218.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_504_7563",
    x1: 130.49,
    y1: 161.516,
    x2: 140.457,
    y2: 161.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_504_7563",
    x1: 164.546,
    y1: 209.126,
    x2: 174.514,
    y2: 209.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_504_7563",
    x1: 181.634,
    y1: 131.76,
    x2: 191.602,
    y2: 131.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_504_7563",
    x1: 207.026,
    y1: 146.525,
    x2: 216.994,
    y2: 146.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_504_7563",
    x1: 23.9554,
    y1: 129.973,
    x2: 40.9835,
    y2: 129.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_504_7563",
    x1: 0.562929,
    y1: 150.465,
    x2: 42.0016,
    y2: 150.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_504_7563",
    x1: 0.562923,
    y1: 160.084,
    x2: 42.0017,
    y2: 160.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_504_7563",
    x1: 294.764,
    y1: 150.465,
    x2: 311.792,
    y2: 150.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_504_7563",
    x1: 295.533,
    y1: 156.36,
    x2: 336.972,
    y2: 156.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_504_7563",
    x1: 295.532,
    y1: 165.979,
    x2: 336.971,
    y2: 165.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_504_7563",
    x1: 231.622,
    y1: 74.385,
    x2: 258.312,
    y2: 74.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_504_7563",
    x1: 131.006,
    y1: 299.279,
    x2: 157.696,
    y2: 299.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_504_7563",
    x1: 56.5857,
    y1: 185.949,
    x2: 83.276,
    y2: 185.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_504_7563",
    x1: 235.252,
    y1: 234.182,
    x2: 261.943,
    y2: 234.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_504_7563",
    x1: 134.369,
    y1: 74.385,
    x2: 161.06,
    y2: 74.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_504_7563",
    x1: 455.527,
    y1: 138.111,
    x2: 673.772,
    y2: 138.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_504_7563",
    x1: 606.754,
    y1: 155.439,
    x2: 643.797,
    y2: 155.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_504_7563",
    x1: 581.17,
    y1: 193.168,
    x2: 606.753,
    y2: 193.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_504_7563",
    x1: 569.476,
    y1: 152.24,
    x2: 606.753,
    y2: 152.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_504_7563",
    x1: 581.125,
    y1: 150.204,
    x2: 606.754,
    y2: 150.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_504_7563",
    x1: 570.276,
    y1: 179.519,
    x2: 606.753,
    y2: 179.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_504_7563",
    x1: 472.403,
    y1: 68.1911,
    x2: 550.358,
    y2: 68.1911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_504_7563",
    x1: 472.384,
    y1: 129.629,
    x2: 550.338,
    y2: 129.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_504_7563",
    x1: 491.128,
    y1: 113.496,
    x2: 531.615,
    y2: 113.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_504_7563",
    x1: 481.382,
    y1: 124.76,
    x2: 541.369,
    y2: 124.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_504_7563",
    x1: 481.372,
    y1: 136.001,
    x2: 541.37,
    y2: 136.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_504_7563",
    x1: 480.064,
    y1: 146.89,
    x2: 541.37,
    y2: 146.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_504_7563",
    x1: 578.451,
    y1: 77.154,
    x2: 592.457,
    y2: 77.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_504_7563",
    x1: 609.228,
    y1: 82.5607,
    x2: 623.234,
    y2: 82.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_504_7563",
    x1: 640.033,
    y1: 87.0605,
    x2: 654.039,
    y2: 87.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_504_7563",
    x1: 260.762,
    y1: 320.302,
    x2: 264.1,
    y2: 320.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_504_7563",
    x1: 274.576,
    y1: 363.226,
    x2: 292.73,
    y2: 363.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#DAEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#D4E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_504_7563",
    x1: 260.165,
    y1: 277.213,
    x2: 268.95,
    y2: 277.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_504_7563",
    x1: 258.774,
    y1: 294.75,
    x2: 266.564,
    y2: 294.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_504_7563",
    x1: 269.557,
    y1: 277.265,
    x2: 277.052,
    y2: 277.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_504_7563",
    x1: 262.203,
    y1: 267.865,
    x2: 275.635,
    y2: 267.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_504_7563",
    x1: 262.647,
    y1: 307.53,
    x2: 292.752,
    y2: 307.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_504_7563",
    x1: 267.358,
    y1: 287.597,
    x2: 259.756,
    y2: 306.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_504_7563",
    x1: 285.376,
    y1: 292.456,
    x2: 291.689,
    y2: 292.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_504_7563",
    x1: 277.712,
    y1: 311.626,
    x2: 292.752,
    y2: 311.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_504_7563",
    x1: 441.934,
    y1: 386.253,
    x2: 458.569,
    y2: 386.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_504_7563",
    x1: 430.207,
    y1: 383.421,
    x2: 446.681,
    y2: 383.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_504_7563",
    x1: 436.812,
    y1: 355.977,
    x2: 447.056,
    y2: 355.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_504_7563",
    x1: 425.402,
    y1: 353.846,
    x2: 435.546,
    y2: 353.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_504_7563",
    x1: 421.11,
    y1: 317.614,
    x2: 452.804,
    y2: 317.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_504_7563",
    x1: 415.347,
    y1: 269.55,
    x2: 430.121,
    y2: 269.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_504_7563",
    x1: 432.485,
    y1: 238.382,
    x2: 446.204,
    y2: 238.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_504_7563",
    x1: 463.985,
    y1: 246.328,
    x2: 471.034,
    y2: 246.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_504_7563",
    x1: 419.436,
    y1: 278.148,
    x2: 466.702,
    y2: 278.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_504_7563",
    x1: 439.789,
    y1: 294.473,
    x2: 447.203,
    y2: 294.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_504_7563",
    x1: 441.839,
    y1: 279.775,
    x2: 448.244,
    y2: 279.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_504_7563",
    x1: 419.436,
    y1: 287.474,
    x2: 431.562,
    y2: 287.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_504_7563",
    x1: 454.269,
    y1: 263.534,
    x2: 457.333,
    y2: 263.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_504_7563",
    x1: 421.329,
    y1: 307.205,
    x2: 442.144,
    y2: 307.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_504_7563",
    x1: 544.968,
    y1: 453.569,
    x2: 486.197,
    y2: 453.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_504_7563",
    x1: 515.591,
    y1: 504.465,
    x2: 486.197,
    y2: 504.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_504_7563",
    x1: 480.376,
    y1: 438.756,
    x2: 421.605,
    y2: 438.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_504_7563",
    x1: 450.999,
    y1: 515.812,
    x2: 421.605,
    y2: 515.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_504_7563",
    x1: 415.725,
    y1: 422.035,
    x2: 356.954,
    y2: 422.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_504_7563",
    x1: 386.349,
    y1: 525.25,
    x2: 356.954,
    y2: 525.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_504_7563",
    x1: 408.639,
    y1: 537.597,
    x2: 305.443,
    y2: 537.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_504_7563",
    x1: 394.789,
    y1: 538.147,
    x2: 320.153,
    y2: 538.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_504_7563",
    x1: 370.165,
    y1: 540.394,
    x2: 349.747,
    y2: 540.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_504_7563",
    x1: 358.271,
    y1: 535.867,
    x2: 346.817,
    y2: 535.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_504_7563",
    x1: 513.244,
    y1: 528.317,
    x2: 464.903,
    y2: 528.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_504_7563",
    x1: 506.757,
    y1: 528.575,
    x2: 471.794,
    y2: 528.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_504_7563",
    x1: 495.222,
    y1: 529.627,
    x2: 485.657,
    y2: 529.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_504_7563",
    x1: 489.651,
    y1: 527.506,
    x2: 484.285,
    y2: 527.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_504_7563",
    x1: 565.65,
    y1: 490.112,
    x2: 535.306,
    y2: 490.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_504_7563",
    x1: 561.578,
    y1: 490.274,
    x2: 539.631,
    y2: 490.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_504_7563",
    x1: 554.337,
    y1: 490.934,
    x2: 548.333,
    y2: 490.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_504_7563",
    x1: 550.84,
    y1: 489.603,
    x2: 547.472,
    y2: 489.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_504_7563",
    x1: 64.1009,
    y1: 421.281,
    x2: 136.158,
    y2: 421.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_504_7563",
    x1: 72.3118,
    y1: 453.54,
    x2: 177.313,
    y2: 453.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_504_7563",
    x1: 40.3949,
    y1: 393.56,
    x2: 96.2585,
    y2: 393.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_504_7563",
    x1: 117.787,
    y1: 555.398,
    x2: 245.478,
    y2: 555.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_504_7563",
    x1: 180.115,
    y1: 548.483,
    x2: 245.478,
    y2: 548.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_504_7563",
    x1: 105.995,
    y1: 413.17,
    x2: 108.934,
    y2: 413.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_504_7563",
    x1: 118.341,
    y1: 321.071,
    x2: 96.5884,
    y2: 321.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_504_7563",
    x1: 384.86,
    y1: 200.079,
    x2: 387.799,
    y2: 200.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_504_7563",
    x1: 397.206,
    y1: 107.98,
    x2: 375.454,
    y2: 107.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_504_7563",
    x1: 598.102,
    y1: 408.646,
    x2: 601.041,
    y2: 408.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_504_7563",
    x1: 610.448,
    y1: 316.548,
    x2: 588.696,
    y2: 316.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls18);
export default __webpack_public_path__ + "static/media/ils_18.0abaa9cd1a10708b31e4d2bf276db894.svg";
export { ForwardRef as ReactComponent };